// Vendors
import styled from 'styled-components';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';

const UploadIdErrorComponentStyled = styled.section`
  padding-top: calc(${({ theme }) => theme.spacing_400} + ${({ theme }) => theme.spacing_300});
  text-align: center;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    padding-top: ${({ theme }) => theme.spacing_300};
  }
`;
UploadIdErrorComponentStyled.displayName = 'UploadIdErrorComponentStyled';

export { UploadIdErrorComponentStyled };
